// Site Configuration - Single Source of Truth for Business Details
// Update this file to change contact info across the entire site

export const siteConfig = {
  // Business Identity
  name: "Apex Medical Group",
  tagline: "Medical Coverage Where It Matters Most",
  description: "Professional event medical services, private home consultations, and certified emergency training delivered by experienced healthcare professionals in Saint Lucia.",
  
  // Contact Information
  contact: {
    phone: {
      primary: "+1 (758) 488-8433",
      display: "+1 (758) 488-8433",
      href: "tel:+17584888433",
    },
    email: {
      primary: "info@apexmedical.lc",
      href: "mailto:info@apexmedical.lc",
    },
    whatsapp: {
      number: "+17584888433",
      href: "https://wa.me/17584888433",
      display: "Chat on WhatsApp",
    },
  },
  
  // Location
  address: {
    street: "Corinth",
    city: "Rodney Bay",
    country: "Saint Lucia",
    full: "Corinth, Rodney Bay, Saint Lucia",
    short: "Rodney Bay, Saint Lucia",
  },
  
  // Business Hours
  hours: {
    weekdays: "8:00 AM - 6:00 PM",
    weekend: "Closed",
    display: "Mon – Fri: 8:00 AM - 6:00 PM",
    note: "Emergency services available 24/7",
  },
  
  // Website
  website: {
    url: "https://apexmedical.lc",
    domain: "apexmedical.lc",
  },
  
  // Social Media Links
  social: {
    facebook: "https://facebook.com/apexmedicallc",
    instagram: "https://instagram.com/apexmedicallc",
    linkedin: "https://linkedin.com/company/apexmedicallc",
    twitter: "https://twitter.com/apexmedicallc",
  },
  
  // Company Info
  company: {
    founded: "2018",
    registration: "Saint Lucia",
    certifications: [
      "ACLS/ATLS/BLS Certified",
      "Licensed Healthcare Provider",
      "Fully Insured & Bonded",
      "Ministry of Health Registered",
    ],
  },
  
  // Team / Directors
  directors: [
    {
      name: "Dr. Marcus Joseph",
      role: "Medical Director & Co-Founder",
      credentials: "MD, FACEP, ACLS",
      bio: "Board-certified emergency physician with over 15 years of experience in acute care and event medicine. Former Chief of Emergency Services at Victoria Hospital. Passionate about bringing world-class medical coverage to the Caribbean region.",
      avatar: "MJ",
    },
    {
      name: "Natasha Charles",
      role: "Operations Director & Co-Founder", 
      credentials: "RN, BSN, MBA",
      bio: "Seasoned healthcare administrator with expertise in clinical operations and emergency response logistics. Previously managed nursing operations for major healthcare systems. Leads strategic partnerships and operational excellence.",
      avatar: "NC",
    },
    {
      name: "Kevin St. Rose",
      role: "Training Director & Co-Founder",
      credentials: "EMT-P, AHA Instructor, PHTLS",
      bio: "Certified paramedic and master instructor with deep expertise in pre-hospital care and emergency medical education. Has trained hundreds of first responders across the Caribbean. Champions community health education initiatives.",
      avatar: "KS",
    },
  ],
  
  // About Content
  about: {
    mission: "To deliver accessible, professional medical services that protect people at events, in their homes, and through life-saving education across Saint Lucia and the Caribbean.",
    vision: "To be the Caribbean's most trusted provider of event medical coverage, mobile healthcare, and emergency training—setting new standards for safety, professionalism, and compassionate care.",
    story: `Apex Medical Group was founded in 2018 by a team of passionate healthcare professionals who recognized a critical gap in event medical services and emergency preparedness across Saint Lucia and the wider Caribbean.

What started as a small team providing medical coverage for local festivals has grown into the region's premier medical services provider, offering comprehensive event coverage, private home consultations, and certified emergency training programs.

Our founders—Dr. Marcus Joseph, Natasha Charles, and Kevin St. Rose—combined their expertise in emergency medicine, healthcare operations, and paramedicine to build an organization that delivers world-class medical care with Caribbean warmth and understanding.

Today, we proudly serve event organizers, families, businesses, and communities across Saint Lucia, bringing peace of mind through professional medical coverage and life-saving education.`,
    values: [
      {
        title: "Safety First",
        description: "Every decision we make prioritizes the health and safety of those under our care.",
      },
      {
        title: "Compassionate Care", 
        description: "We treat every patient with dignity, respect, and genuine concern for their wellbeing.",
      },
      {
        title: "Rapid Response",
        description: "Our teams are trained to act swiftly and decisively in any medical emergency.",
      },
      {
        title: "Excellence",
        description: "We maintain the highest standards of medical practice and continuous improvement.",
      },
    ],
  },
  
  // SEO & Metadata
  seo: {
    title: "Apex Medical Group | Event Medical Coverage & Emergency Training | Saint Lucia",
    description: "Professional event medical services, private home consultations, and certified First Aid & CPR training in Saint Lucia. Trusted healthcare when and where you need it.",
    keywords: "event medical coverage, first aid training, CPR certification, home medical visits, Saint Lucia healthcare, emergency medical services, event safety, Caribbean medical services",
    ogImage: "/og-image.jpg",
  },
};

export default siteConfig;
